import UsersView from '../../pages/UsersView';

// Nome simples (PT): Página de Equipa
export default function PaginaEquipa(props) {
  return <UsersView {...props} />;
}






